/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_JSXRuntime as JSXRuntime,
  rec_React as React,
  rec_ReactCompiler as ReactCompiler,
  rec_api as api,
  rec_cx as cx,
  rec_ii as ii,
} from "../../runtime/index.jsx";
export function CambiarContrasena(e) {
  let t = (0, ReactCompiler.c)(31),
    { contrasenaActual: n, onListo: r } = e,
    [i, a] = (0, React.useState)(``),
    [o, s] = (0, React.useState)(``),
    [c, l] = (0, React.useState)(n || ``),
    [u, f] = (0, React.useState)(``),
    [p, m] = (0, React.useState)(!1),
    h;
  t[0] !== c || t[1] !== i || t[2] !== r || t[3] !== o
    ? ((h = async function (e) {
        if ((e.preventDefault(), i !== o)) {
          f(`Las dos contraseñas tienen que ser iguales.`);
          return;
        }
        (m(!0), f(``));
        try {
          (await api(`/auth/cambiar-contrasena`, {
            method: `POST`,
            body: JSON.stringify({
              contrasenaActual: c,
              contrasenaNueva: i,
            }),
            redirigirEn401: !1,
          }),
            r());
        } catch (e) {
          (f(e.message || `No se pudo cambiar la contraseña`), m(!1));
        }
      }),
      (t[0] = c),
      (t[1] = i),
      (t[2] = r),
      (t[3] = o),
      (t[4] = h))
    : (h = t[4]);
  let _ = h,
    v;
  t[5] !== c || t[6] !== n
    ? ((v = !n && (
        <input
          className={cx.replace(`pl-11`, `pl-4`)}
          type={`password`}
          placeholder={`Contraseña actual`}
          value={c}
          onChange={(e) => l(e.target.value)}
          required={!0}
        />
      )),
      (t[5] = c),
      (t[6] = n),
      (t[7] = v))
    : (v = t[7]);
  let y;
  t[8] === Symbol.for(`react.memo_cache_sentinel`)
    ? ((y = cx.replace(`pl-11`, `pl-4`)), (t[8] = y))
    : (y = t[8]);
  let b;
  t[9] === Symbol.for(`react.memo_cache_sentinel`)
    ? ((b = (e) => a(e.target.value)), (t[9] = b))
    : (b = t[9]);
  let x;
  t[10] === i
    ? (x = t[11])
    : ((x = (
        <input
          className={y}
          type={`password`}
          placeholder={`Tu contraseña nueva`}
          value={i}
          onChange={b}
          required={!0}
          autoFocus={!0}
        />
      )),
      (t[10] = i),
      (t[11] = x));
  let S;
  t[12] === Symbol.for(`react.memo_cache_sentinel`)
    ? ((S = cx.replace(`pl-11`, `pl-4`)), (t[12] = S))
    : (S = t[12]);
  let C;
  t[13] === Symbol.for(`react.memo_cache_sentinel`)
    ? ((C = (e) => s(e.target.value)), (t[13] = C))
    : (C = t[13]);
  let w;
  t[14] === o
    ? (w = t[15])
    : ((w = (
        <input
          className={S}
          type={`password`}
          placeholder={`Repetila`}
          value={o}
          onChange={C}
          required={!0}
        />
      )),
      (t[14] = o),
      (t[15] = w));
  let T;
  t[16] === Symbol.for(`react.memo_cache_sentinel`)
    ? ((T = (
        <p
          className={`text-xs text-(--text)`}
          children={`Al menos 8 caracteres, con una mayúscula y un número.`}
        />
      )),
      (t[16] = T))
    : (T = t[16]);
  let E;
  t[17] === u
    ? (E = t[18])
    : ((E = u && <p className={`text-sm text-(--error)`} children={u} />),
      (t[17] = u),
      (t[18] = E));
  let D;
  t[19] === p
    ? (D = t[20])
    : ((D =
        p &&
        (0, JSXRuntime.jsx)(ii, {
          className: `mr-1 inline h-4 w-4 animate-spin`,
        })),
      (t[19] = p),
      (t[20] = D));
  let O;
  t[21] !== p || t[22] !== D
    ? ((O = (
        <button
          type={`submit`}
          disabled={p}
          className={`w-full rounded-full bg-(--accent) py-3 text-sm font-medium text-(--accent-fg) transition hover:opacity-90 disabled:opacity-50`}
          children={[D, `Guardar y entrar`]}
        />
      )),
      (t[21] = p),
      (t[22] = D),
      (t[23] = O))
    : (O = t[23]);
  let k;
  return (
    t[24] !== _ ||
    t[25] !== E ||
    t[26] !== O ||
    t[27] !== v ||
    t[28] !== x ||
    t[29] !== w
      ? ((k = (
          <form
            className={`mt-6 flex flex-col gap-4`}
            onSubmit={_}
            children={[v, x, w, T, E, O]}
          />
        )),
        (t[24] = _),
        (t[25] = E),
        (t[26] = O),
        (t[27] = v),
        (t[28] = x),
        (t[29] = w),
        (t[30] = k))
      : (k = t[30]),
    k
  );
}
